export default __webpack_public_path__ + "locales/ro/SendInviteDialog.json?hash=296c0ebfee04c82d48a388b3b35c3e4a";